import { useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { IDENTITY_ERROR_CODES, isIdentityApiError } from '@identity/application/errors';

/** Where the whole application already sends a caller whose session died. */
const SESSION_EXPIRED_ROUTE = '/logged-out';

/**
 * Sends the user to the session expired screen when a failure says the Parrot session is gone.
 *
 * It is mounted by the screens of the flow that runs inside a session, and not written as a response
 * interceptor: the same rejection on a flow that runs on a link means an unusable link, and an
 * interceptor would have to tell apart again what the repository already told apart.
 */
export const useSessionExpiredExit = (error: unknown): void => {
  const history = useHistory();
  const hasExpired = isIdentityApiError(error) && error.code === IDENTITY_ERROR_CODES.EXPIRED_TOKEN;

  useEffect(() => {
    if (hasExpired) history.push(SESSION_EXPIRED_ROUTE);
  }, [hasExpired, history]);
};
